<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>Numeracy</strong> by
        <a href="https://stewartmckee.name">Stewart McKee</a>. The source code
        is licensed
        <a href="http://opensource.org/licenses/mit-license.php">MIT</a>.
      </p>
      <p>
        <a
          rel="license"
          href="http://creativecommons.org/licenses/by-nc-sa/4.0/"
          ><img
            alt="Creative Commons Licence"
            style="border-width:0"
            src="https://i.creativecommons.org/l/by-nc-sa/4.0/88x31.png"/></a
        ><br />This work is licensed under a
        <a
          rel="license"
          href="http://creativecommons.org/licenses/by-nc-sa/4.0/"
          >Creative Commons Attribution-NonCommercial-ShareAlike 4.0
          International License</a
        >.
      </p>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
footer {
  margin-top: 30px;
}
</style>
